// We support images being added and hyperlinked via markdown syntax, e.g. ![alt text](my-image.jpg)
//
// The matcher regex will look for text structured like so:
//   Opens with ![
//     Contains text <- This is the alt text and the first capturing group in the regex, matches[1]
//   Ends with ]
//   Opens (
//     Contains text <- This is the URL for the image (both source and hyperlink) and the second capturing group in the regex, matches[2]
//   Closes whole input with )
export const INPUT_RULE_MARKDOWN_IMAGE = {
  type: 'custom',
  matcher: /(?:[\s\S])?^\!\[(.+?)\]\((.+?)(?:\s.*?)?\)/,
  handler(state, match, start, end) {
    let altText = match[1];
    let url = match[2];
    let imageNode = state.schema.nodes.image.create({
      src: url,
      linkUrl: url,
      text: altText
    });
    let tr = state.tr.replaceWith(start, end, imageNode);
    return tr;
  }
};